<div id="newDivScrollTarget" class="product-listing-slider" *ngIf="slides.length != 0">
    <div class="d-flex justify-content-between align-items-center new-content-box mb-3">
        <h2 class="section-heading mb-0">New In <span class="simple-font-family">({{totalCount > 0 ? totalCount :
                0}})</span></h2>
        <a (click)="listClick($event, 'All', '/product/listing/New')" class=" view-all-new" style="">View All</a>
    </div>
    <div class="product-listing-slider-wrapper custom-slider-home">
        <ngx-slick-carousel class="carousel d-md-block d-none" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide" id="product_diff_{{slide.product_id}}">
                <ul class="product-type" *ngIf="slide.price_marked == 1">
                    <li>
                        <img src="../../assets/images/pmp.svg" alt="checked icon" />
                    </li>
                </ul>
                <div class="product-wrapper">
                    <div class="product-image">
                        <a (click)="redirectToProductDetail(slide.url)" href='javascript:void(0);'> <img
                                src="{{ slide.img }}" alt="" width="100%"> </a>
                    </div>
                    <div class="product-description">
                        <div class="new-heading-gram">
                            <div>
                                <h2>{{ slide.productName }}</h2>
                                <span class="light-text-des">{{slide.barcode}} | {{slide.sku}}</span>
                            </div>
                            <span class="light-text-des">({{slide.unit_size}})</span>
                        </div>
                        <ul class="order-quantity-details">
                            <li>
                                <span>RSP</span>
                                <p> <span class="text-dark" *ngIf="slide.rsp !== '0.00'">£{{slide.rsp}}</span>
                                    <span class="text-dark" *ngIf="slide.rsp == '0.00'">N/A</span>
                                    <span class="each"
                                        *ngIf="slide.rsp != '0.00' && (slide.sale_unit != '' && (slide.sale_unit == 'Kilo' || slide.sale_unit == 'Each'))">per
                                        100g</span>
                                    <span class="each"
                                        *ngIf="slide.rsp != '0.00' && (slide.sale_unit != '' && slide.sale_unit.indexOf('C') !== -1)">each</span>
                                </p>
                            </li>
                            <li *ngIf="global_data?.margin_visibility == 1">
                                <span>Margin</span>
                                <p><span class="text-dark">{{slide.margin}}%</span></p>
                            </li>
                            <!-- <li *ngIf="global_data?.margin_visibility == 1">
                                <span>Margin</span>
                                <p><span class="text-dark">{{sharedService.getStoreVatFreeMargin(slide)}}%</span></p>
                            </li> -->
                            <li>
                                <span>Case</span>
                                <p><strong class="text-dark">{{slide.size_case}}</strong></p>
                            </li>
                            <li *ngIf="global_data?.price_visibility == 1">
                                <span>Cost</span>
                                <p><strong>£{{slide.price}}</strong></p>
                            </li>
                        </ul>
                        <button
                            [ngClass]="{'btn primary-btn':true, 'disabled':slide.back_in_stock == '0' ?true : false}"
                            id="dont_btn1_{{slide.product_id}}"
                            *ngIf="slide.item_id == '' && miniCartDetails?.items_count != 0"
                            (click)="addToCart(slide, slide.qty, '', 'common', commonTemplate,commonTemplateFor24HrPopup, true)">Add</button>
                        <button
                            [ngClass]="{'btn primary-btn':true, 'disabled':slide.back_in_stock == '0' ?true : false}"
                            id="dont_btn_{{slide.product_id}}"
                            *ngIf="slide.item_id == '' && miniCartDetails?.items_count == 0"
                            (click)="addToCart(slide, slide.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,true)">Add</button>
                        <p *ngIf="slide.back_in_stock == '0'" class="product-cart-status d-none d-md-flex"> <img
                                src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock
                        </p>

                        <ngx-number-spinner id="spiner__btn_{{slide.product_id}}" *ngIf="slide.item_id != ''"
                            [ngClass]="{'spinner':true, 'disabled':slide.back_in_stock == '0' ?true : false}"
                            [value]="toInteger(slide.qty)" [min]="0"
                            (change)="qytChange(slide, $event, commonTemplate)">
                        </ngx-number-spinner>
                    </div>
                </div>
            </div>
        </ngx-slick-carousel>
        <ngx-slick-carousel class="carousel d-md-none d-block custom-product-slider" #slickModal="slick-carousel"
            [config]="slideConfig_mobile">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide" id="product_diff_{{slide.product_id}}">
                <ul class="product-type" *ngIf="slide.price_marked == 1">
                    <li>
                        <img src="../../assets/images/pmp.svg" alt="checked icon" />
                    </li>
                </ul>
                <div class="product-wrapper">
                    <div class="product-image">
                        <a (click)="redirectToProductDetail(slide.url)" href='javascript:void(0);'> <img
                                src="{{ slide.img }}" alt="" width="100%"> </a>
                    </div>
                    <div class="product-description">
                        <h2>{{ slide.productName }}</h2>
                        <ul class="order-quantity-details">
                            <li>
                                <span>RSP</span>
                                <p> <span *ngIf="slide.rsp !== '0.00'">£{{slide.rsp}}</span>
                                    <span *ngIf="slide.rsp == '0.00'">N/A</span>
                                    <span class="each"
                                        *ngIf="slide.rsp != '0.00' && (slide.sale_unit != '' && (slide.sale_unit == 'Kilo' || slide.sale_unit == 'Each'))">per
                                        100g</span>
                                    <span class="each"
                                        *ngIf="slide.rsp != '0.00' && (slide.sale_unit != '' && slide.sale_unit.indexOf('C') !== -1)">each</span>
                                </p>
                            </li>
                            <li *ngIf="global_data?.margin_visibility == 1">
                                <span>Margin</span>
                                <p><span class="text-dark">{{slide.margin}}%</span></p>
                            </li>
                            <!-- <li *ngIf="global_data?.margin_visibility == 1 && global_data?.vat_exempt == 1">
                                <span>Margin</span>
                                <p><span class="text-dark">{{getCalculatedMargin()}}%</span></p>
                            </li> -->
                            <li *ngIf="global_data?.price_visibility == 1">
                                <span>Cost</span>
                                <p><strong>£{{slide.price}}</strong></p>
                            </li>
                        </ul>
                        <button
                            [ngClass]="{'btn primary-btn':true, 'disabled':slide.back_in_stock == '0' ?true : false}"
                            id="dont_btn1_{{slide.product_id}}"
                            *ngIf="slide.item_id == '' && miniCartDetails?.items_count != 0"
                            (click)="addToCart(slide, slide.qty, '', 'common', commonTemplate,true,commonTemplateFor24HrPopup)">Add</button>
                        <button
                            [ngClass]="{'btn primary-btn':true, 'disabled':slide.back_in_stock == '0' ?true : false}"
                            id="dont_btn_{{slide.product_id}}"
                            *ngIf="slide.item_id == '' && miniCartDetails?.items_count == 0"
                            (click)="addToCart(slide, slide.qty, addToCartTemplate, 'cart', commonTemplate,true,commonTemplateFor24HrPopup)">Add</button>
                        <p *ngIf="slide.back_in_stock == '0'" class="product-cart-status d-none d-md-flex"> <img
                                src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock
                        </p>

                        <ngx-number-spinner id="spiner__btn_{{slide.product_id}}" *ngIf="slide.item_id != ''"
                            [ngClass]="{'spinner':true, 'disabled':slide.back_in_stock == '0' ?true : false}"
                            [value]="toInteger(slide.qty)" [min]="0"
                            (change)="qytChange(slide, $event, commonTemplate)">
                        </ngx-number-spinner>
                    </div>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</div>
<ng-template #addToCartTemplate>
    <div class="modal-header border-0 pb-2 align-items-center flex-column">
        <h4 class="modal-title">Info</h4>
        <p>You are about to create a order for</p>
        <h4 class="modal-title">{{selectedStore.selectedStoreName}}</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Please change the store if you want to create an order for another store.</p>
                </div>
                <div class="button-success text-center mt-3">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Ok</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commonTemplate>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>{{popupMessage}} </p>
                </div>
                <div class="button-div text-center mt-3 align-items-center">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">{{commonBottonText}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commonTemplateFor24HrPopup>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p style="white-space: pre-wrap">{{popupMessage}} </p>
                </div>
                <div class="button-div text-center mt-3 align-items-center">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button mr-3"
                        (click)="addToCart(product_for_24_hr, product_for_24_hr.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,false)">{{commonBottonText}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>